import { CollectionModel } from '@ikegps/core-shared';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m } from '../../mithril';
import { TopologicalEditorController } from '../../page/topological.editor.page';
import { classNames } from '../../util/classnames';
import { CSS, Style } from './topological.editor.collection.list.style';

addStyles(Style);

interface ITopologicalEditorCollectionListOptions {
	onItemClick: (id: string) => void;
	selectedRevision?: string | null;
	collections: CollectionModel[];
	collectionsEditController: TopologicalEditorController;
}

export const TopologicalEditorCollectionList = {
	view(options: ITopologicalEditorCollectionListOptions) {
		return m(
			'div',
			{ className: CSS.container },
			options.collections.map((pole) =>
				pole
					? m(
							'div',
							{
								className: classNames(CSS.item, {
									[CSS.selected]: options.selectedRevision === pole.revision,
									[CSS.noLocation]: !pole.location,
								}),
								role: 'button',
								tabindex: '0',
								onclick: () => options.onItemClick(pole.revision),
							},
							[
								m(
									'div',
									{
										className: classNames({
											[CSS.unsaved]: options.collectionsEditController.collectionHasChanges(pole.revision),
										}),
									},
									[
										pole.title ? pole.title : Translate(T.COLLECTION_MISSING_TITLE),
										pole.isMissingTrueSize() ? m('span', { className: CSS.redDot }) : null,
									]
								),
								m(
									'div',
									{
										className: CSS.info,
									},
									options.collectionsEditController.collectionHasChanges(pole.revision)
										? `(${Translate(T.TOPO_UNSAVED_COLLECTION)})`
										: ''
								),
							]
						)
					: null
			)
		);
	},
};
